import React from 'react';
import { FORMAL_QUOTE_OPTIONS } from 'formal_quote/options';

const LicenseScopeCards = ({
  value,
  onChange,
  disabled,
  error,
  inputName = 'license_scope',
  legend = 'Quote Type',
  options = FORMAL_QUOTE_OPTIONS.license_scope,
}) => (
  <fieldset className="formal-quote-license-scope">
    <legend className="license-scope-legend font-heavy">
      {legend} <span className="text-danger">*</span>
    </legend>
    <div className="license-scope-options">
      {Object.entries(options).map(
        ([scopeValue, scope]) => (
          <label
            key={scopeValue}
            htmlFor={`${inputName}_${scopeValue}`}
            className={`license-scope-card${value === scopeValue ? ' is-selected' : ''}${disabled ? ' is-disabled' : ''}`}
          >
            <input
              type="radio"
              id={`${inputName}_${scopeValue}`}
              name={inputName}
              value={scopeValue}
              checked={value === scopeValue}
              disabled={disabled}
              onChange={onChange}
              className="license-scope-input"
            />
            <span className="license-scope-indicator" aria-hidden="true" />
            <span className="license-scope-copy">
              <span className="license-scope-title font-heavy">
                {scope.label}
              </span>
              <span className="license-scope-description font-medium">
                {scope.description}
              </span>
            </span>
          </label>
        ),
      )}
    </div>
    {error && <div className="invalid-feedback d-block">{error}</div>}
  </fieldset>
);

export default LicenseScopeCards;
